import moment from 'moment';

export function isDataStillFresh(lastFetchedAt: Date) {
  return moment().diff(lastFetchedAt, 'minutes', true) <= 5;
}
